/* JCI EDITS - static Model -> Make(s) lookup.
 *
 * The Model filter (filter.p.m.custom.multiple_models) has no built-in link
 * back to Make - "3", "1500" or "Silverado" mean nothing without knowing
 * which brand(s) they belong to. Search & Discovery's filter API doesn't
 * expose that relationship (a model value carries no make/vendor of its
 * own), so this is a maintained lookup instead of a live query.
 *
 * Used to label Model options with their Make(s) everywhere the Model list
 * is shown unscoped (i.e. before a Make is chosen) - see
 * jci-product-query-control.liquid and jci-mobile-filters.liquid/js. The
 * shared decorator lives in jci-product-listing.js (decorateModelLabels).
 *
 * VALUES ARE ARRAYS - most models belong to exactly one make, but several
 * genuinely span more than one:
 *   - badge-engineered platform twins really are sold under multiple
 *     brands (BRZ: Scion/Subaru; Mark LT: Ford/Lincoln; 1500/2500/3500:
 *     Dodge/Ram/GMC share body/headlight housings across generations).
 *   - a few entries reflect actual tagging inconsistencies already present
 *     in the live product data (e.g. a "Fiat 500" product tagged Ford; a
 *     "Sierra 1500"-tagged product that's actually a Toyota 4Runner part).
 *     Rather than silently guess a single "correct" brand and hide the
 *     mismatch, this lists exactly what the live catalog's own tags say -
 *     that's the honest state of the data, and worth the merchant fixing
 *     upstream in the product tags themselves.
 *   - two Make values in the live Make filter are themselves lowercase
 *     ("kawasaki", "mini cooper") - kept verbatim here to stay consistent
 *     with how they render everywhere else Make is shown, rather than
 *     introducing a differently-cased spelling that exists nowhere else.
 *
 * Regenerated 2026-08-21 by cross-referencing all 100 live Model filter
 * values against /collections/all?filter.p.m.custom.multiple_models=<value>
 * and collecting the distinct product-tag Makes each one actually returns
 * (not by eyeballing a partial sample - do the same for any regeneration).
 */
window.JCIModelMakeMap = {
  // BMW
  '3 Series': ['BMW'],
  'M3': ['BMW'],

  // Cadillac
  'CTS': ['Cadillac'],
  'Escalade': ['Cadillac'],

  // Chevrolet
  'Avalanche': ['Chevrolet'],
  'Camaro': ['Chevrolet'],
  'Cavalier': ['Chevrolet'],
  'Corvette': ['Chevrolet'],
  'Equinox': ['Chevrolet'],
  'Impala': ['Chevrolet'],
  'Sierra 1500': ['Chevrolet', 'GMC', 'Toyota'],
  'Sierra 2500HD': ['Chevrolet', 'GMC', 'Toyota'],
  'Sierra 3500HD': ['Chevrolet', 'GMC', 'Toyota'],
  'Silverado': ['Chevrolet'],
  'Silverado 1500': ['Chevrolet'],
  'Silverado 2500HD': ['Chevrolet'],
  'Silverado 3500HD': ['Chevrolet'],
  'Suburban': ['Chevrolet'],
  'Tahoe': ['Chevrolet'],

  // Chrysler
  '300': ['Chrysler'],
  '300C': ['Chrysler'],

  // Dodge
  '1500': ['Dodge', 'GMC', 'Ram'],
  '2500': ['Dodge', 'Ram'],
  '3500': ['Dodge', 'Ram'],
  'Challenger': ['Dodge'],
  'Charger': ['Dodge'],
  'Durango': ['Dodge'],

  // Fiat
  '500': ['Fiat', 'Ford'],

  // Ford
  'Bronco': ['Ford'],
  'Excursion': ['Ford'],
  'Expedition': ['Ford'],
  'Explorer': ['Ford'],
  'F-150': ['Ford'],
  'F-150 Raptor': ['Ford'],
  'F-250': ['Ford'],
  'F-350': ['Ford'],
  'Focus': ['Ford'],
  'Fusion': ['Ford'],
  'Mark LT': ['Ford', 'Lincoln'],
  'Mustang': ['Ford'],
  'Ranger': ['Ford'],
  'Raptor': ['Ford'],
  'Super Duty': ['Ford'],

  // GMC
  '2500HD': ['GMC'],
  '3500HD': ['GMC'],
  'Sierra': ['GMC'],
  'Yukon': ['GMC'],

  // Honda
  'Accord': ['Honda'],
  'Accord Coupe': ['Honda'],
  'CBR-1000RR': ['Honda'],
  'Civic': ['Honda'],
  'Civic Coupe': ['Honda'],
  'S2000': ['Honda'],

  // Hyundai
  'Elantra': ['Hyundai'],
  'Genesis Coupe': ['Hyundai'],
  'Genesis Sedan': ['Hyundai'],

  // Infiniti
  'G35 Coupe': ['Infiniti'],
  'G37': ['Infiniti'],
  'G37 Sedan': ['Infiniti'],
  'Q60': ['Infiniti'],

  // Jeep
  'Compass': ['Jeep'],
  'Gladiator JT': ['Jeep'],
  'Grand Cherokee': ['Jeep'],
  'JL': ['Jeep'],
  'Liberty': ['Jeep'],
  'Wrangler': ['Jeep'],
  'Wrangler JK': ['Jeep'],
  'Wrangler JL': ['Jeep'],

  // Kia
  'K5': ['Kia'],

  // Lexus
  'GX 460': ['Lexus'],
  'IS': ['Lexus'],

  // Mazda
  '3': ['Mazda'],
  '6': ['Mazda'],

  // Mitsubishi
  'Evo': ['Mitsubishi'],

  // Nissan
  '370Z': ['Nissan'],
  'Altima': ['Nissan'],
  'Frontier': ['Nissan'],
  'GTR': ['Nissan'],
  'Maxima': ['Nissan'],
  'Titan': ['Nissan'],
  'Xterra': ['Nissan'],

  // Porsche
  '911': ['Porsche'],
  '912': ['Porsche'],
  '964': ['Porsche'],

  // Ram
  '4500': ['Ram'],
  '5500': ['Ram'],
  'HD': ['Ram'],

  // Scion
  'BRZ': ['Scion', 'Subaru'],
  'FR-S': ['Scion'],
  'GT86': ['Scion'],
  'TC': ['Scion'],

  // Subaru
  'GR86': ['Subaru'],
  'Impreza WRX': ['Subaru'],
  'WRX STI': ['Subaru'],

  // Tesla
  'Model 3': ['Tesla'],

  // Toyota
  '4Runner': ['Toyota'],
  'Camry': ['Toyota'],
  'Tacoma': ['Toyota'],
  'Tundra': ['Toyota'],

  // mini cooper (kept lowercase - matches the live Make filter's own label)
  'Hatchback': ['mini cooper']
};
